<template>
  <div>
    <Navbar />
    <div
      data-ix="navbar-grow"
      class="page-header-overlay page-header-overlay-clear"
    >
      <div class="w-container container">
        <h1
          data-ix="fade-in-on-load"
          class="page-header-title"
        >
          Get in touch
        </h1>
      </div>
    </div>
    <!-- <div
      data-ix="navbar-grow"
      class="w-section contact-map-wrapper"
    >
      <div
        data-widget-latlng="33.619411,-117.872677"
        data-widget-style=""
        data-widget-zoom="10"
        data-disable-touch="1"
        data-disable-scroll="1"
        class="w-widget w-widget-map contact-map"
      />
    </div> -->
    <div class="w-section section">
      <div class="w-container container home-intro-container">
        <div class="w-row home-intro-row">
          <div class="w-col w-col-4 home-intro-column">
            <div class="w-clearfix home-intro-block contact">
              <img
                src="/images/icon-home-black.png"
                data-ix="fade-in-on-load"
                class="w-editable intro-block-icon"
              >
              <div
                data-ix="fade-in-on-load"
                class="w-editable intro-block-title"
              >
                Our office
              </div>
              <p
                data-ix="fade-in-on-load"
                class="w-editable"
              >
                <strong>You can find us at:</strong>
                <br>620 Newport Center Drive, Suite 1100
                <br>Newport&nbsp;Beach,&nbsp;California
              </p>
            </div>
          </div>
          <div class="w-col w-col-4 home-intro-column">
            <div class="home-intro-block contact">
              <img
                src="/images/Icon-phone.png"
                data-ix="fade-in-on-load-2"
                class="w-editable intro-block-icon"
              >
              <div
                data-ix="fade-in-on-load-2"
                class="w-editable intro-block-title"
              >
                Contact us
              </div>
              <p
                data-ix="fade-in-on-load-2"
                class="w-editable"
              >
                <strong>You can call us at:</strong>
                <br>
                <a
                  class="link"
                  href="tel:8774117627"
                >
                  +1(877)&nbsp;411-ROAR&nbsp;(7627)
                </a>
              </p>
            </div>
          </div>
          <div class="w-col w-col-4 home-intro-column">
            <div class="home-intro-block last contact">
              <img
                src="/images/Icon-mail.png"
                data-ix="fade-in-on-load-2"
                class="w-editable intro-block-icon"
              >
              <div
                data-ix="fade-in-on-load-3"
                class="w-editable intro-block-title"
              >
                Email us at:
              </div>
              <a
                class="link"
                href="mailto:info@roaringsky.com"
              >
                info@roaringsky.com
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="w-container container">
        <div
          data-ix="fade-in-on-scroll-2"
          class="info-text-block contact-form"
        >
          <div class="w-editable intro-block-title">
            Send an email
          </div>
          <div class="w-form contact-form">
            <form
              id="wf-form-Contact-Form"
              name="wf-form-Contact-Form"
              data-name="Contact Form"
              :submit="submit"
              action="#"
              method="post"
              @submit.prevent="submit"
            >
              <input
                id="name"
                v-model="contactForm.name"
                v-validate="'required'"
                type="text"
                placeholder="Enter your name"
                name="name"
                data-name="Name"
                class="w-input field"
              >
              <div class="errors text-danger">
                <span v-show="errors.has('name')">
                  A name is required.
                </span>
              </div>
              <input
                id="Email-address"
                v-model="contactForm.email"
                v-validate="'required'"
                type="email"
                placeholder="Email address"
                name="email"
                data-name="email"
                class="w-input field"
              >
              <div class="errors text-danger">
                <span v-show="errors.has('email')">
                  An email is required.
                </span>
              </div>
              <input
                id="Phone-number"
                v-model="contactForm.phone"
                v-validate="'required|numeric'"
                type="text"
                placeholder="Phone number"
                name="phone"
                data-name="phone"
                class="w-input field"
              >
              <div class="errors text-danger">
                <span v-show="errors.has('phone')">
                  A phone is required.
                </span>
              </div>
              <textarea
                id="Message"
                v-model="contactForm.message"
                v-validate="'required'"
                placeholder="Your message..."
                name="message"
                data-name="Message"
                class="w-input field area"
              />
              <div class="errors text-danger">
                <span v-show="errors.has('message')">
                  A message is required.
                </span>
              </div>
              <input
                type="submit"
                value="Send email"
                data-wait="Please wait..."
                class="w-button button" />
              <br>
              <br>
              <VueRecaptcha
                sitekey="6LdZ34AUAAAAAEgkBGOGebF-h-hQuYQToheG_Tmu"
                @verify="onVerify" />
              <div class="errors text-danger">
                <span
                  v-show="submitAttempt && !recaptchaResponse">
                  Please complete the reCAPTCHA to submit feedback.
                </span>
              </div>
            </form>
            <br>
            <div
              v-if="submitSuccess"
              class="w-form-done success-bg"
            >
              <p>Thank you! Your submission has been received!</p>
            </div>
            <div
              v-if="submitFailure"
              class="w-form-fail error-bg">
              <p class="error-text">
                Oops!&nbsp;Something went wrong. Please try again
              </p>
            </div>
          </div>
        </div>
        <div
          data-ix="fade-in-on-scroll"
          class="info-image-block contact" />
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import VueRecaptcha from 'vue-recaptcha'

import Navbar from '@/components/TheNavbar'
import Footer from '@/components/TheFooter'
export default {
  name: 'NotFound',
  components: {
    Navbar,
    Footer,
    VueRecaptcha,
  },

  data() {
    return {
      submitSuccess: false,
      submitFailure: false,
      contactForm: {},
      submitAttempt: false,
      recaptchaResponse: '',
    }
  },

  mounted() {
    setTimeout(() => {
      // eslint-disable-next-line
      $(Webflow.ready)
    }, 1)
  },
  destroyed() {
    // eslint-disable-next-line
    $(Webflow.destroy)
  },
  methods: {
    ...mapActions(['submitContact']),
    submit() {
      this.submitAttempt = true
      this.$validator.validate().then(result => {
        if (result && this.recaptchaResponse) {
          // handle submit
          this.submitContact(this.contactForm)
            .then(() => {
              this.contactForm = {}
              this.submitSuccess = true
              setTimeout(() => {
                this.submitSuccess = false
              }, 3000)
            })
            .catch(() => {
              // error
            })
        }
      })
    },
    onVerify(response) {
      this.recaptchaResponse = response
    },
  },
}
</script>

<style>
.text-danger {
  color: red;
}

.info-text-block.contact-form {
  height: auto;
}

.info-image-block.contact {
  height: 680px;
}

.w-form-done,
.w-form-fail {
  display: block;
}
</style>
